import type {Sponsored} from '@/redux/v1/models';

export const createP195Classname = (
  offer?: null | {sponsored?: Sponsored | null}
) => {
  return offer?.sponsored ? `FID_${offer.sponsored.flightId}` : '';
};
